import { gql } from '@apollo/client'

export const REMOVE_WORKSPACE_INVITATION = gql`
  mutation RemoveWorkspaceInvitation($workspaceId: UUID!, $teamId: ID!, $email: LowercaseString!) {
    removeWorkspaceInvitation(workspaceId: $workspaceId, teamId: $teamId, email: $email) {
      success
    }
  }
`
